export default __webpack_public_path__ + "static/media/sowmz-castlerock-crop.7f6ca998.jpg";